import React from 'react';
import { injectIntl } from 'react-intl';
import get from 'lodash/get';

// Component we can get intl out of
class IntlExposer extends React.PureComponent {
  constructor() {
    super();

    if (!IntlExposer.instance) {
      IntlExposer.instance = this;
    }
  }

  render() {
    return false;
  }
}

export default injectIntl(IntlExposer);

export const getIntl = () => {
  return get(IntlExposer, 'instance.props.intl');
};
